import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import NavbarComponent from '../Components/NavbarComponent';
import LowestNavbar from '../Components/LowestNavbar';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import projectBlogs from './projectBlogs';

export default function BlogDetails() {
  const history = useHistory();
  const { id } = useParams();

  const blog = projectBlogs.find((item) => String(item.id) === String(id));

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return null;

    const regExp =
      /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);

    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  const youtubeEmbedUrl = getYoutubeEmbedUrl(blog?.links?.youtube);

  if (!blog) {
    return (
      <div className="d-flex flex-column min-vh-100">
        <NavbarComponent />
        <main
          className="flex-grow-1 pt-5 mt-5 px-3"
          style={{ backgroundColor: '#f8fafc' }}
        >
          <Container className="pt-5 text-center">
            <h3 className="fw-bold mb-3">Project not found</h3>
            <p className="text-muted mb-4">
              The case study you are trying to open does not exist.
            </p>
            <Button variant="dark" onClick={() => history.push('/blog')}>
              ← Go Back
            </Button>
          </Container>
        </main>
        <LowestNavbar />
      </div>
    );
  }

  const sectionCardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    padding: '28px',
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
    marginBottom: '24px',
  };

  const sectionTitleStyle = {
    fontSize: '1.35rem',
    fontWeight: 700,
    color: '#0f172a',
    marginBottom: '14px',
  };

  const paragraphStyle = {
    fontSize: '1rem',
    lineHeight: '1.9',
    color: '#334155',
    marginBottom: 0,
  };

  const listStyle = {
    marginBottom: 0,
    paddingLeft: '1.2rem',
    color: '#334155',
    lineHeight: '1.9',
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <NavbarComponent />

      <main
        className="flex-grow-1 pt-5 mt-5 px-3"
        style={{ backgroundColor: '#f8fafc' }}
      >
        <Container className="pt-4 pb-5" style={{ maxWidth: '980px' }}>
          <div className="mb-4">
            <Button
              variant="outline-dark"
              onClick={() => {history.push('/blog')

                window.location.reload();
              }}
              style={{
                borderRadius: '999px',
                padding: '0.55rem 1rem',
                fontWeight: 600,
              }}
            >
              ← Back to Projects
            </Button>
          </div>

          <div
            style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
              borderRadius: '24px',
              padding: '36px',
              color: '#fff',
              marginBottom: '28px',
            }}
          >
            <div className="mb-3 d-flex flex-wrap gap-2 align-items-center">
              <span
                style={{
                  backgroundColor: 'rgba(255,255,255,0.14)',
                  padding: '0.5rem 0.9rem',
                  borderRadius: '999px',
                  fontSize: '0.82rem',
                  fontWeight: 600,
                }}
              >
                {blog.category}
              </span>

              {blog.blogDate && (
                <span
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.10)',
                    padding: '0.5rem 0.9rem',
                    borderRadius: '999px',
                    fontSize: '0.82rem',
                    fontWeight: 500,
                    color: 'rgba(255,255,255,0.9)',
                  }}
                >
                  {blog.blogDate}
                </span>
              )}
            </div>

            <h1
              className="fw-bold mb-3"
              style={{
                fontSize: '2.3rem',
                lineHeight: '1.3',
              }}
            >
              {blog.title}
            </h1>

            <p
              style={{
                fontSize: '1.08rem',
                lineHeight: '1.9',
                color: 'rgba(255,255,255,0.9)',
                maxWidth: '850px',
                marginBottom: '1.2rem',
              }}
            >
              {blog.tagline}
            </p>

            <p
              style={{
                fontSize: '1rem',
                lineHeight: '1.8',
                color: 'rgba(255,255,255,0.82)',
                maxWidth: '850px',
                marginBottom: '1.5rem',
              }}
            >
              {blog.shortDescription}
            </p>

            <div className="d-flex flex-wrap gap-2">
              {blog.tags?.map((tag, index) => (
                <span
                  key={index}
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.12)',
                    color: '#fff',
                    padding: '0.42rem 0.8rem',
                    borderRadius: '999px',
                    fontSize: '0.82rem',
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {blog.coverImage && (
            <div
              style={{
                borderRadius: '24px',
                overflow: 'hidden',
                marginBottom: '28px',
                boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
              }}
            >
              <img
                src={blog.coverImage}
                alt={blog.title}
                style={{
                  width: '100%',
                  maxHeight: '460px',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </div>
          )}

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Use Case</h2>
            <p style={paragraphStyle}>{blog.useCase}</p>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Project Description</h2>
            <p style={paragraphStyle}>{blog.description}</p>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>What It Does</h2>
            <ul style={listStyle}>
              {blog.whatItDoes?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>System Design</h2>

            <div className="mb-4">
              <h5 className="fw-bold" style={{ color: '#1e293b' }}>
                Architecture Flow
              </h5>
              <p
                style={{
                  ...paragraphStyle,
                  backgroundColor: '#f1f5f9',
                  padding: '16px',
                  borderRadius: '14px',
                  marginTop: '10px',
                }}
              >
                {blog.systemDesign?.architectureFlow}
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-bold" style={{ color: '#1e293b' }}>
                Overview
              </h5>
              <p style={paragraphStyle}>{blog.systemDesign?.overview}</p>
            </div>

            <div className="mb-4">
              <h5 className="fw-bold" style={{ color: '#1e293b' }}>
                Scene Structure
              </h5>
              <ul style={listStyle}>
                {blog.systemDesign?.sceneStructure?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {blog.architectureDiagram && (
              <div>
                <h5 className="fw-bold mb-3" style={{ color: '#1e293b' }}>
                  Architecture Diagram
                </h5>
                <div
                  style={{
                    borderRadius: '20px',
                    overflow: 'hidden',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#fff',
                    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.05)',
                  }}
                >
                  <img
                    src={blog.architectureDiagram}
                    alt={`${blog.title} Architecture Diagram`}
                    style={{
                      width: '100%',
                      display: 'block',
                      objectFit: 'contain',
                      backgroundColor: '#ffffff',
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Technology Stack</h2>

            <div className="mb-3">
              <h5 className="fw-bold" style={{ color: '#1e293b' }}>
                Frontend
              </h5>
              <p style={paragraphStyle}>{blog.techStack?.frontend?.join(', ')}</p>
            </div>

            <div className="mb-3">
              <h5 className="fw-bold" style={{ color: '#1e293b' }}>
                Backend
              </h5>
              <p style={paragraphStyle}>{blog.techStack?.backend?.join(', ')}</p>
            </div>

            <div className="mb-3">
              <h5 className="fw-bold" style={{ color: '#1e293b' }}>
                AI / Cloud
              </h5>
              <p style={paragraphStyle}>{blog.techStack?.aiCloud?.join(', ')}</p>
            </div>

            <div>
              <h5 className="fw-bold" style={{ color: '#1e293b' }}>
                DevOps / Deployment
              </h5>
              <p style={paragraphStyle}>{blog.techStack?.devops?.join(', ')}</p>
            </div>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Key Features</h2>
            <ul style={listStyle}>
              {blog.keyFeatures?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Challenges Faced</h2>
            <ul style={listStyle}>
              {blog.challenges?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Solutions & Learnings</h2>
            <p style={paragraphStyle}>{blog.solutionsAndLearnings}</p>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Accomplishments</h2>
            <ul style={listStyle}>
              {blog.accomplishments?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Future Scope</h2>
            <ul style={listStyle}>
              {blog.futureScope?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div style={sectionCardStyle}>
            <h2 style={sectionTitleStyle}>Project Video</h2>

            {youtubeEmbedUrl ? (
              <>
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    paddingBottom: '56.25%',
                    borderRadius: '18px',
                    overflow: 'hidden',
                    marginBottom: '18px',
                    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
                    backgroundColor: '#000',
                  }}
                >
                  <iframe
                    src={youtubeEmbedUrl}
                    title={`${blog.title} YouTube Video`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                    }}
                  />
                </div>

                <a
                  href={blog.links.youtube}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-block',
                    textDecoration: 'none',
                    backgroundColor: '#ff0000',
                    color: '#fff',
                    padding: '0.8rem 1.1rem',
                    borderRadius: '999px',
                    fontWeight: 600,
                  }}
                >
                  Watch on YouTube
                </a>
              </>
            ) : (
              <p style={paragraphStyle}>No YouTube video added yet.</p>
            )}
          </div>
        </Container>
      </main>

      <LowestNavbar />
    </div>
  );
}